// XFace: one expression cropped from the character's 3x2 face sheet (faces.jpg, 1200x800).
// e: 0 calm · 1 dry smile · 2 laughing · 3 at work · 4 warm · 5 flustered (FACE in characters.ts).
import type { JSX } from 'preact';
import type { CharId } from '@shared/types';
import { C } from '@shared/content/characters';

export interface XFaceProps {
  ch: CharId;
  /** Expression 0-5 (default 4, warm). */
  e?: number;
  /** Diameter in px (default 96). */
  s?: number;
  /** Ring colour (2px, 3px from 80px up). Usually the accent: ring="var(--acc)". */
  ring?: string;
  /** Rounded square (radius 14) instead of a circle. */
  square?: boolean;
  /** Alt text. Default "{name}, {mood}". Pass '' when a neighbouring label already names the buddy. */
  alt?: string;
  class?: string;
  style?: JSX.CSSProperties;
}

const MOOD = ['calm', 'dry smile', 'laughing', 'at work', 'warm', 'flustered'];

export function XFace({ ch, e = 4, s = 96, ring, square, alt, class: cls, style }: XFaceProps) {
  const ex = Math.max(0, Math.min(5, Math.round(e) || 0));
  const col = ex % 3, row = Math.floor(ex / 3);
  return (
    <div
      class={cls}
      style={{
        width: s, height: s, borderRadius: square ? 14 : '50%', overflow: 'hidden', position: 'relative', background: '#8E8A84',
        boxShadow: ring ? `0 0 0 ${s >= 80 ? 3 : 2}px ${ring}` : 'none', flex: 'none', ...style,
      }}
    >
      <img
        src={C[ch].assets.faces}
        alt={alt != null ? alt : `${C[ch].name}, ${MOOD[ex]}`}
        draggable={false}
        style={{
          position: 'absolute', width: Math.round(s * 3.3), height: Math.round(s * 2.2), maxWidth: 'none',
          left: -Math.round(col * 1.1 * s + 0.05 * s), top: -Math.round(row * 1.1 * s + 0.05 * s),
        }}
      />
    </div>
  );
}
